import React from "react";

export default function SignerFieldOverlay({ preview, onFieldClick }) {
  const DISPLAY_SCALE = 0.6;

  if (!preview || !preview.pages) {
    return <div>Loading document preview...</div>;
  }

  const allCompleted =
    (preview.totalFields || 0) > 0 &&
    preview.completedFields === preview.totalFields;

  return (
    <div>
      {preview.pages.map((page) => {
        const displayWidth = page.width * DISPLAY_SCALE;
        const displayHeight = page.height * DISPLAY_SCALE;

        return (
          <div key={page.pageNumber} style={{ marginBottom: 24 }}>
            <div
              style={{
                position: "relative",
                width: displayWidth,
                height: displayHeight,
                border: "1px solid #e5e7eb",
                borderRadius: 12,
                overflow: "hidden",
                background: "#fff"
              }}
            >
              <img
                src={page.imageUrl}
                alt={`Page ${page.pageNumber}`}
                style={{
                  width: displayWidth,
                  height: displayHeight,
                  display: "block"
                }}
              />

              {(preview.fields || [])
                .filter((field) => field.pageNumber === page.pageNumber)
                .map((field) => {
                  const left = field.xRatio * displayWidth;
                  const top = field.yRatio * displayHeight;
                  const width = field.widthRatio * displayWidth;
                  const height = field.heightRatio * displayHeight;

                  const isLocked =
                    allCompleted || !preview.otpVerified || !preview.canSignNow;

                  return (
                    <div
                      key={field.fieldId}
                      onClick={() => {
                        if (!field.completed && !allCompleted) {
                          onFieldClick(field);
                        }
                      }}
                      style={{
                        position: "absolute",
                        left,
                        top,
                        width,
                        height,
                        border: field.completed
                          ? "2px solid #16a34a"
                          : isLocked
                          ? "2px dashed #9ca3af"
                          : "2px dashed #f59e0b",
                        background: field.completed
                          ? "rgba(22,163,74,0.15)"
                          : isLocked
                          ? "rgba(156,163,175,0.14)"
                          : "rgba(245,158,11,0.18)",
                        cursor:
                          field.completed || allCompleted ? "default" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                        fontSize: 12,
                        color: "#111827",
                        textAlign: "center"
                      }}
                    >
                      {field.completed
                        ? "SIGNED"
                        : allCompleted
                        ? "COMPLETED"
                        : isLocked
                        ? "VERIFY TO SIGN"
                        : "SIGN HERE"}
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
}